import React from 'react';
import { Briefcase, Home } from 'lucide-react';
import { motion } from 'motion/react';
import { SidebarWorkspaceSwitcherProps } from './types';

export const SidebarWorkspaceSwitcher: React.FC<SidebarWorkspaceSwitcherProps> = React.memo(({
  activeWorkspace,
  isCollapsed,
  onWorkspaceChange
}) => {
  return (
    <div 
      className={`sticky top-0 z-[40] bg-slate-100/90 dark:bg-slate-950/95 backdrop-blur-md px-3 flex items-center justify-center border-b border-slate-200/50 dark:border-slate-800/60 shadow-[0_2px_8px_rgba(0,0,0,0.03)] dark:shadow-[0_2px_8px_rgba(0,0,0,0.2)] transition-all ${isCollapsed ? 'opacity-0 h-0 pointer-events-none' : 'opacity-100'}`}
      style={{ height: '60px', boxSizing: 'border-box' }}
    >
      <div className="bg-slate-100/80 dark:bg-slate-800/50 p-1 rounded-xl border border-slate-200/50 dark:border-slate-800/50 flex relative mx-auto w-full max-w-[280px] shadow-inner items-center h-[34px]">
        {/* Animated Background Slider */}
        <motion.div
          className={`absolute top-1 bottom-1 w-[calc(50%-4px)] rounded-lg shadow-sm z-0 transition-shadow duration-300 ${
            activeWorkspace === 'professional' 
              ? 'bg-white dark:bg-slate-700 left-1 ring-1 ring-indigo-500/10 shadow-indigo-500/5' 
              : 'bg-white dark:bg-slate-700 left-[calc(50%+1px)] ring-1 ring-emerald-500/10 shadow-emerald-500/5'
          }`}
          layoutId="workspace-slider"
          transition={{ type: "spring", bounce: 0.2, duration: 0.4 }}
        />
        
        <button 
          type="button"
          onClick={() => {
            onWorkspaceChange('professional');
          }}
          className={`flex-1 flex items-center justify-center gap-2 py-1.5 rounded-lg text-[10px] font-black uppercase tracking-widest relative z-10 transition-all duration-300 ${
            activeWorkspace === 'professional' 
              ? 'text-indigo-600 dark:text-indigo-400' 
              : 'text-slate-500 dark:text-slate-500 hover:text-slate-800 dark:hover:text-slate-200'
          }`}
        >
          <Briefcase size={12} />
          <span>Beruf</span>
        </button>
        
        <button 
          type="button"
          onClick={() => {
            onWorkspaceChange('private');
          }}
          className={`flex-1 flex items-center justify-center gap-2 py-1.5 rounded-lg text-[10px] font-black uppercase tracking-widest relative z-10 transition-all duration-300 ${
            activeWorkspace === 'private' 
              ? 'text-emerald-600 dark:text-emerald-400' 
              : 'text-slate-500 dark:text-slate-500 hover:text-slate-800 dark:hover:text-slate-200'
          }`}
        >
          <Home size={12} />
          <span>Privat</span>
        </button>
      </div>
    </div>
  );
});
